module.exports = __webpack_public_path__ + "static/img/demob.a70c5150.png";